<template>
  <b-card-code :title="this.$route.meta.pageTitle">

    <b-row class="mb-2">
        <b-col>
          <b-button-group>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="loading"
                @click="$router.push('/stats/malaria')"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Agregar</span>
            </b-button>
          </b-button-group>
        </b-col>
        <b-col class="text-right">
          <b-button-group>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                :disabled="loading"
                @click="onBtExport()"
            >
              <feather-icon
                  icon="DownloadIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar a Excel</span>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>

    <div class="text-center pt-4" v-if="loading">
      <b-spinner label="Cargando..."/>
      Cargando...
    </div>

    <div v-if="rowData.length > 0">
      <ag-grid-vue
          style="width: 100%; height: 100%;"
          class="ag-theme-alpine custom-grid"
          ref="agGrid"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
          domLayout='autoHeight'
          :columnDefs="columnDefs"
          :autoGroupColumnDef="this.gridOptions.autoGroupColumnDef"
          :defaultColDef="this.gridOptions.defaultColDef"
          :excelStyles="this.gridOptions.excelStyles"
          :suppressRowClickSelection="true"
          :groupSelectsChildren="true"
          :pagination="true"
          :paginationPageSize="this.gridOptions.paginationPageSize"
          :rowData="rowData"
          :defaultExcelExportParams="this.gridOptions.defaultExcelExportParams"
          :cacheQuickFilter="true">
        >
      </ag-grid-vue>
    </div>
    <b-row v-if="rowData.length === 0">
      <b-col>
        No se encontraron registros en el rango de fecha.
      </b-col>
    </b-row>


    <!--    Toast-->
    <b-toast id="example-toast" variant="primary">
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-center mr-1">
          <b-img
              src="/logo.jpeg"
              class="mr-1"
              height="18"
              width="18"
              alt="Icon"
          />
          <strong class="mr-auto">Alerta</strong>
        </div>
      </template>
      <span>La fecha <strong>Desde</strong> debe ser menor a la fecha <strong>Hasta</strong>. </span>
    </b-toast>
  </b-card-code>
</template>

<script>
import {
  BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BButtonGroup,
  BButton, BDropdown, BDropdownItem, BFormDatepicker, BToast, BSpinner, BFormFile, BForm
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import {AgGridVue} from "ag-grid-vue";
import { gridDef } from "@/views/stats/ag-grid-conf";
import environment from "@/environment";
import flatPickr from 'vue-flatpickr-component'
import vSelect from "vue-select";
import {format} from "date-fns";


export default {
  name: 'MalariaList',
  components: {
    BForm, BFormFile,
    BButtonGroup,
    flatPickr,
    vSelect,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    BToast,
    BSpinner,
    BCardCode,
    AgGridVue
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Fecha",
          field: "dateE",
          valueFormatter: (params) => {
            return params.value ? format(new Date(params.value), 'dd-MM-yyyy') : '';
          },
          resizable: true
        },
        { headerName: "Semana", field: "week", resizable: true },
        {
          headerName: "Región",
          field: 'regionLabel',
          resizable: true,
        },
        {
          headerName: "Distrito",
          field: 'districtLabel',
          resizable: true,

        },
        {
          headerName: "Corregimiento",
          field: 'corregimientoLabel',
          resizable: true,

        },
        {
          headerName: "Localidad",
          field: 'localidadLabel',
          resizable: true,

        },
        {
          headerName: "Localidades Trabajadas",
          field: 'localidades',
          resizable: true,

        },
        {
          headerName: 'Visitas',
          headerClass: 'headerCenter',
          children: [
            {
              headerName: "Casas",
              field: 'casas1',
              resizable: true,

            },
            {
              headerName: "Cent. Educ.",
              field: 'centEduc',
              resizable: true,

            },
            {
              headerName: "Aut. Locales",
              field: 'autLocales',
              resizable: true,

            },
            {
              headerName: "Inst. Salud",
              field: 'instSalud',
              resizable: true,

            },
          ]
        },
        {
          headerName: 'Muestras Tomadas',
          headerClass: 'headerCenter',
          children: [
            {
              headerName: "PDR",
              field: 'prd',
              resizable: true,

            },
            {
              headerName: "PDR Positivos",
              field: 'prdPositivo',
              resizable: true,

            },
            {
              headerName: "GG",
              field: 'gg',
              resizable: true,

            },
            {
              headerName: "GG Positivo",
              field: 'ggPositivo',
              resizable: true,

            },
            {
              headerName: "Total positivas",
              field: 'totalPositivos',
              resizable: true,

            },
          ]
        },

        {
          headerName: 'Positivos',
          headerClass: 'headerCenter',
          children: [
            {
              headerName: "Tratamientos",
              field: 'tratamientos',
              resizable: true,

            },
            {
              headerName: "Investigados",
              field: 'investigados',
              resizable: true,

            },
            {
              headerName: "Vivax",
              field: 'vivax',
              resizable: true,

            },
            {
              headerName: "Falciparun",
              field: 'falciparun',
              resizable: true,

            },
          ]
        },
        {
          headerName: 'Intervenciones',
          headerClass: 'headerCenter',
          children: [
            {
              headerName: "Roc",
              field: 'roc1',
              resizable: true,

            },
            {
              headerName: 'Neb',
              headerClass: 'headerCenter',
              children: [
                {
                  headerName: "Casas",
                  field: 'casas2',
                  resizable: true,

                },
                {
                  headerName: "Abrigos",
                  field: 'abrigos',
                  resizable: true,

                },
              ]
            },
            {
              headerName: 'Químico',
              headerClass: 'headerCenter',
              children: [
                {
                  headerName: "Roc / Kg",
                  field: 'roc2',
                  resizable: true,

                },
                {
                  headerName: "Neb / Lt",
                  field: 'neb',
                  resizable: true,

                },
              ]
            }
          ]
        },

        {
          headerName: 'Colecta de Adultos',
          headerClass: 'headerCenter',
          children: [
            {
              headerName: "N° de mosquitos",
              field: 'nMosquitos',
              resizable: true,

            },
          ]
        },

        {
          headerName: 'Control Lavario. Nº de Criaderos Anophelinos',
          headerClass: 'headerCenter',
          children: [
            {
              headerName: "Enc.",
              field: 'enc',
              resizable: true,

            },
            {
              headerName: "Trat.",
              field: 'trat',
              resizable: true,

            },
            {
              headerName: "Larv. Gast/lbs",
              field: 'larvGast',
              resizable: true,

            },
            {
              headerName: "Eval.",
              field: 'eval',
              resizable: true,

            },
          ]
        },

        {
          headerName: '',
          cellRenderer: params => this.linkEditDocument(params.data._id),
          minWidth: 90
        },
      ],
      rowData: [],
      gridApi: null,
      paginationPageSize: null,
      loading: false,
      gridOptions: gridDef(),
    };
  },
  computed: {
    rangeFrom() {
      return this.rangeDate.substring(0, 10)
    },
    rangeTo() {
      if (this.rangeDate.length > 11) {
        return this.rangeDate.slice(-10)
      }
    }

  },
  beforeMount() {
    this.paginationPageSize = 50;
    this.paginationNumberFormatter = (params) => {
      return '[' + params.value.toLocaleString() + ']';
    };
    this.gridOptions = gridDef(this.$route.meta.pageTitle)
  },
  mounted() {
    this.searchJsonData()
  },
  methods: {
    linkEditDocument(id) {
      const link = document.createElement('a');
      link.href = `/stats/malaria/malariaEdit/${id}`;
      link.textContent = 'Editar';
      link.className = 'detailsLink';

      return link;
    },

    onBtExport() {
      let params = {
        fileName: `${this.$route.meta.pageTitle}-${this.getCurrentDateTime()}.xlsx`,
        exportMode: 'xlsx',
      };
      console.log(this.gridApi.exportDataAsExcel(params))
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.refreshHeader();
      this.gridApi.refreshCells();
      this.gridApi.setHeaderHeight(24);
    },

    searchJsonData() {
      this.loading = true
      this.$http.get(`${environment.uri}stats/malaria`)
          .then(response => {
            this.rowData = response.data;
            this.loading = false
          })
          .catch(error => {
            console.log(error);
            this.loading = false
          })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import "~ag-grid-community/styles/ag-grid.css";
@import "~ag-grid-community/styles/ag-theme-alpine.css";
@import "@/assets/scss/custom-ag.scss";
@import '@core/scss/vue/libs/vue-select.scss';


.ag-header-row-column-group{
  background-color: var(--light) !important;
  color: var(--dark) !important;
}
</style>








